/* eslint-disable */
import {
  mapGetters
} from 'vuex';
import toast from '../../services/toast';
import countries from '../../services/phone.json';
import flagUser from '../../components/flag-user/index';
import {
  bus
} from '../../main';
export default {
  name: 'userDetail',
  components: {
    'flag-user': flagUser
  },
  props: [],
  data() {
    return {
      showTab: 'personal',
      userData: {},
      countryList: [],
      contestQuizPoints:{},
      showblock:'fav_courses',
      userQuizHistories:{},
      userQuizHistoriesResults:[],
      userFlagPopup: false,
      userFlagId: '',
      userFlagStatus: ''
    }
  },
  computed: {
    ...mapGetters([
      'getUserDetailsByIdState',
      'userPointsObtainedGetters',
      'getUserQuizHistoryGetters'
    ]),
    getUserList() {
      return this.userData = this.$store.getters.getUserDetailsByIdState.data
    },
    getUserQuizHistoriesFun(){
      return this.userQuizHistories = this.$store.getters.getUserQuizHistoryGetters.data

    },
    setintialStateofHistories(){
      if(this.userQuizHistories != undefined){
        this.userQuizHistoriesResults = this.userQuizHistories.results
        return
      }
    },
    getContestQuizPoints(){
      return this.contestQuizPoints = this.$store.getters.userPointsObtainedGetters.data
    }
  },
  mounted() {
    bus.$on('UserFlagPopupBus', (data) => {
      this.userFlagPopup = data.show;
      if(data.refresh) {
        this.getUserListAgain();
      }
    });
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserList
    this.getContestQuizPoints
    this.getUserQuizHistoriesFun
    this.setintialStateofHistories
  },
  methods: {
    convertToJsonParse(code){
      return JSON.parse(code);
    },
    convertToAcademicJsonParse(code){
      return JSON.parse(code);
    },
    showFlagUnflagUserPopup(userId, flagStatus) {
      this.userFlagId = userId;
      this.userFlagStatus = flagStatus;
      this.userFlagPopup = true;
    },
    cvFileDownFun: function () {
      window.open(this.userData.user_details.profile.cv, "_blank");
    },
    getCountryCode(mobile) {
      let countryCode = mobile.split(' ')[0];
      countryCode = countryCode.replace('+', '');
      let country = this.countryList.filter(item => (item.name) == (countryCode));
      if (country && country.length > 0) {
        country = country[0]
        country = `https://www.countryflags.io/${country.value}/shiny/32.png`
      } else {
        country = ''
      }
      return country;
    },
    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    getUserListAgain() {
      this.$store.dispatch('getUserListDetailsById',{id: this.userData.user_details.id}).then((res) => {}).catch((err) => {})
    },
    showtab(value) {
      this.showblock = value;
    },
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getUserDetailsByIdState
    },
    getContestQuizPoints(){
      return this.$store.getters.userPointsObtainedGetters
    },
    getUserQuizHistoriesFun(){
      return this.$store.getters.getUserQuizHistoryGetters
    },
    setintialStateofHistories(){
      if(this.userQuizHistories != undefined){
        this.userQuizHistoriesResults = this.userQuizHistories.results
        return
      }
    },
  }
}
